export const default_limit = 30
export const default_order = 'DESC'
export const default_confirm_title = 'Are you sure about this?'
export const default_confirm_message = 'You are about to execute an operation that cannot be undone and is necessary that you confirm if you really want to run it'

